import { state } from '@/lib/state'

// TODO: rename to sth related to where it is used (in FormState.vue) so it is not confused with the state object
export const questionTypeToRawComponent = {
  'Highest Education': 'DropDown',
  Sector: 'DropDown',
  'Primary Area': 'DropDown',
  'Primary Function': 'DropDown',
  Leadership: 'Radio',
  Region: 'DropDown',
}

export const svgSpritemapSrc = `${window.location.origin}/dist/salary-app/assets/salary-app-spritemap.svg`

// Map the keys from the API to the keys in the dictionary
const dictionary = {
  p_CompanyCar: 'Salary.BenefitsPercentages.CompanyCar',
  p_Newspaper: 'Salary.BenefitsPercentages.Newspaper',
  p_MediaLicense: 'Salary.BenefitsPercentages.MediaLicense',
  p_Associations: 'Salary.BenefitsPercentages.Associations',
  p_Internet: 'Salary.BenefitsPercentages.Internet',
  p_CompanyMobile: 'Salary.BenefitsPercentages.Phone',
  p_ProfessionalSubscription: 'Salary.BenefitsPercentages.ProfessionalAccount',
  p_PC: 'Salary.BenefitsPercentages.Computer',
  p_Stock: 'Salary.BenefitsPercentages.Stock',
  p_Loan: 'Salary.BenefitsPercentages.Loan',
  p_Wellness: 'Salary.BenefitsPercentages.Wellness',
  p_Bonus: 'Salary.BenefitsPercentages.Profit',
  p_Fruit: 'Salary.BenefitsPercentages.Fruit',
  p_GrossSalary: 'Salary.BenefitsPercentages.GrossSalary',
  p_Fitness: 'Salary.BenefitsPercentages.Fitness',
  p_VacationHomes: 'Salary.BenefitsPercentages.HolidayHomes',
  p_CommuterCard: 'Salary.BenefitsPercentages.CommuterCard',
  p_Parking: 'Salary.BenefitsPercentages.Parking',
}

export function getBenefitDictionaryItem(key) {
  return dictionary[key] || key
}

// TODO: should it be dictionary values?
export const regionNames = {
  q2_CapitalRegion: 'Salary.Geography.CapitalRegion',
  q2_CentralJutland: 'Salary.Geography.CentralJutland',
  q2_NorthJutland: 'Salary.Geography.NorthJutland',
  q2_Zealand: 'Salary.Geography.Zealand',
  q2_SouthernDenmark: 'Salary.Geography.SouthernDenmark',
}

export const QUARTILE_MAP = [
  { step: 25, key: 'q1' },
  { step: 50, key: 'q2' },
  { step: 75, key: 'q3' },
  { step: 90, key: 'q4' },
]

export function getQuartileKey(base, quartile) {
  return quartile === 'q2' ? base : `${base}${quartile}`
}

export function getRegionSalaries(resultData) {
  const mappedSalaries = {}

  Object.keys(resultData).forEach((key) => {
    if (regionNames[key]) {
      mappedSalaries[regionNames[key]] = resultData[key]
    }
  })
  return mappedSalaries
}

export function getRelatedWorkFunctions(workAreaId) {
  const selectedWorkArea = state.lists['workareas'].find(
    (workArea) => workArea.workareaid === workAreaId,
  )
  return selectedWorkArea?.position || []
}
